import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import GestorLayout from '../../components/GestorLayout';
import Regras from './Regras';
import RegrasNotificacoes from './RegrasNotificacoes';
import ApiDocumentation from './ApiDocumentation';
import SistemaStatus from './SistemaStatus';
import { BookOpen, Bell, Layers, Activity, Settings } from 'lucide-react';

const TABS = [
  { id: 'regras', label: 'Regras', icon: BookOpen },
  { id: 'push', label: 'Regras Push', icon: Bell },
  { id: 'api', label: 'API & Fluxos', icon: Layers },
  { id: 'status', label: 'Sistema', icon: Activity },
];

export default function SistemasPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'regras';
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setSearchParams({ tab: tabId });
  };

  return (
    <GestorLayout>
      <div className="space-y-6" data-testid="sistemas-page">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-heading font-bold text-stone-900 flex items-center gap-2">
            <Settings className="h-6 w-6 text-primary" />
            Sistemas
          </h1>
          <p className="text-stone-500 text-sm mt-1">
            Regras, notificações, documentação e estado do sistema
          </p>
        </div>

        {/* Tab bar */}
        <div className="flex gap-1 border-b border-stone-200">
          {TABS.map(tab => {
            const TabIcon = tab.icon;
            return (
            <button
              key={tab.id}
              onClick={() => handleTabChange(tab.id)}
              data-testid={`sistemas-tab-${tab.id}`}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-[1px] ${
                activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-stone-500 hover:text-stone-700 hover:border-stone-300'
              }`}
            >
              <TabIcon className="h-4 w-4" />
              {tab.label}
            </button>
            );
          })}
        </div>

        {/* Tab content */}
        <div data-testid={`sistemas-content-${activeTab}`}>
          {activeTab === 'regras' && <Regras embedded />}
          {activeTab === 'push' && <RegrasNotificacoes embedded />}
          {activeTab === 'api' && <ApiDocumentation embedded />}
          {activeTab === 'status' && <SistemaStatus embedded />}
        </div>
      </div>
    </GestorLayout>
  );
}
